"use client";

import { MoonIcon, SunIcon } from "@heroicons/react/24/outline";
import { Button } from "@packages/components/ui/Button";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

interface ThemeToggleProps {
  noText?: boolean;
}

export default function ThemeToggle({ noText }: ThemeToggleProps) {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <Button
      aria-label={`Switch to ${resolvedTheme === "dark" ? "light" : "dark"} theme`}
      className={`${noText ? "rounded-md" : "w-full justify-between rounded-none"} transition-colors`}
      onClick={() => setTheme(resolvedTheme === "dark" ? "light" : "dark")}
      variant="noStyles"
      size="none"
    >
      {!noText && (
        <span>
          Switch to {resolvedTheme === "dark" ? "Light" : "Dark"} Mode
        </span>
      )}
      <div className="rounded-full" role="img" aria-hidden="true">
        <SunIcon className="block size-5 dark:hidden" />
        <MoonIcon className="hidden size-5 dark:block" />
      </div>
    </Button>
  );
}
